/* eslint-disable react/prop-types */
//import React from 'react';
import React, { useState, useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom';
import Novasala from './novasala';
import SalaLista from './salalista';
import SalaEdit from './salaedit';

import AuthUser from '../../components/AuthUser';


const SalaIndex = ({ match }) => {

     // eslint-disable-next-line no-unused-vars
     const { verificarPermissao } = AuthUser();
     // eslint-disable-next-line no-unused-vars
     const [permissaoVer, setPermissaoVer] = useState(false);
     const [permissaoAdicionar, setPermissaoAdicionar] = useState(false);
     const [permissaoAtualizar, setPermissaoAtualizar] = useState(false);
     const [permissaoAtivar, setPermissaoAtivar] = useState(false);
     const [permissaoRemover, setPermissaoRemover] = useState(false);
 
     useEffect(() => {
 
         setPermissaoVer(verificarPermissao('SALA','ver'));
         setPermissaoAdicionar(verificarPermissao('SALA','adicionar'));
         setPermissaoAtualizar(verificarPermissao('SALA','atualizar'));
         setPermissaoAtivar(verificarPermissao('SALA','ativar'));
         setPermissaoRemover(verificarPermissao('SALA','remover'));
 
     },);
 
     return (
    <Switch>

        <Redirect exact from={`${match.url}/`}  render={(props) => <Novasala {...props} permissaoAdicionar={permissaoAdicionar} />} />

        <Route path={`${match.url}/novasala`} render={(props) => <Novasala {...props} permissaoAdicionar={permissaoAdicionar} />} />

        <Route path={`${match.url}/salaLista`}  render={(props) => <SalaLista {...props} permissaoVer={permissaoVer} permissaoAtivar={permissaoAtivar} permissaoRemover={permissaoRemover} />} />

        <Route path={`${match.url}/salaedit/:id`} render={(props) => <SalaEdit {...props} permissaoAtualizar={permissaoAtualizar} permissaoAtivar={permissaoAtivar} />} />

    </Switch>)
}

export default SalaIndex